import script from "./TestLive.vue?vue&type=script&setup=true&lang=js"
export * from "./TestLive.vue?vue&type=script&setup=true&lang=js"

import "./TestLive.vue?vue&type=style&index=0&id=56b08a39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b08a39"]])

export default __exports__